// extracted by mini-css-extract-plugin
export var header = "index-module--header--fa996";
export var headerSticky = "index-module--header--sticky--5fec0";
export var header__logo = "index-module--header__logo--4569e";
export var header__logoImage = "index-module--header__logo-image--e3518";
export var header__navigation = "index-module--header__navigation--81074";
export var header__phoneWrapper = "index-module--header__phone-wrapper--1cbc4";